export default {
  hasEditSettingsPermissions: false,
  scanGroups: [],
  scanAccounts: [],
  groupInformation: {},
  scanPopulation: {},
  groupScheduling: [],
  adSyncResult: [],
  advancedSettingsConnectivity: {},
  advancedSettingsPrivacy: {},
  advancedMasterSlave: {},
  advancedDomainsWhiteListing: [],
  advancedScanThrottling: {},
  advancedRemediationConfiguration: {},
  advancedDecoyFilesListeningPort: 0,
  advancedUiTimeoutMinutes: 0,
  advancedPoliciesExcludes: [],
  advancedSignatures: [],
  advancedErrrors: {},

  //configuration
  excludedIpRanges: [],
  trafficAdapters: [],

  //configuraion - proxy
  selectedProxyParser: '',
  selectedProxyFolder: '',
  proxyParsers: [],
  proxyParsersFolders: [],
  validationLineResult: {},
  validationLine: '',

  //configuraion - vpn
  selectedVpnParser: '',
  selectedVpnFolder: '',
  vpnParsers: [],
  vpnParsersFolders: [],
  vpnValidationLineResult: {},
  vpnValidationLine: '',
  userAdParams: [],
  userCsvParams: [],

  //users
  users: [],

  //analysis
  analysisSmartSimulation: {},

  //alerts
  alertsGeneralSettings: {},
  alertsNotificationSettings: {},
  alertsAutoHostScan: [],
  alertMinimumSeverity: 0,

  //system info
  systemInfo: {},

  //maps settings
  mapsData: [],
  editRegions: false,
  editRegionsMapId: null,
  regionData: [],

  //eps configuration
  selectedSignatureId: -1,
  signatures: [],

  // Active Directory
  activeDirectoryGroups: [],
  activeDirectoryIdentitiesEnabled: [],
  connectionsAD: [],
  authenticationMode: 0,

  //vulnerability management
  selectedVulnerabilityTabId: 0,
  windowsCriticalPatches: [],
  riskyApplications: [],
  outdatedApplications: [],
  runningApplications: [],

  // Uba Evnets
  ubaEvents: [],

  //threat hunting
  threatHuntingSearchCriteria: [],
  threatHuntingSearchMeta: { isSuppress: false, severity: 3 },

  //decoy files
  decoyFilesArray: [],
  decoyGroupsAndFolders: [],
  GroupWithDecoyEnabled: [],

  sites: [],
  usersByLoggedInUser: [],
  allSlavesSites: [],
  allSlavesSystemStatus: [],
  shouldShowEdit: false,

  //SIEM
  siemSlaveSitesSettings: [],
  siemSlaveSitesStatuses: [],
  siemAllSettings: {},
  globalManagmentSiemSettings: {},

  //scangroups
  scanGroupFeatures: [],
  selectedScanGroupFeatureId: 0,
  slaveSitesScanGroups: [],
  slaveSitesScanGroupsStatus:
    [] /* represents the status message of a slave site(per slave site), when clicking save-all */,
  multipleEditScanGroup: {} /* represents a group edit form which will affect all the slave sites  */,
  //site config

  slaveSitesConfig: [],
  multipleEditConfigValue: {},
  //WEB PROXY
  webProxies: [],

  //CISO KIT
  cisoKitConnections: [],
  enableIPhoneConnection: false,
  enableIPadConnection: false,
  isCisoKitEnabled: false,

  globalServerVersion: '0.0.0.0',
  siteBillingSettings: {},

  userTags: [],
  //Cloud Email recipients
  SitesEmailRecipients: [],
  multipleEditEmailRecipientsValue: {}
};
